/* global swal angular _ */
import './style.less';
import { get } from 'lodash';

export default function($q, $location, $stateParams, $uibModal, $log, ApiClass, HelperClass, ResolveClass, Swal) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  function updateContextOverrides(user, content_overrides) {
    user.content_overrides = content_overrides;

    for (const type in content_overrides) {
      for (const id in content_overrides[type]) {
        const { completed, exempt, updated_at } = content_overrides[type][id];

        user.progress[type][id].exempt = exempt;
        user.progress[type][id].completed = completed;
        user.progress[type][id].updated_at = updated_at;
        user.progress[type][id].status = completed ? 1 : exempt ? -1 : 0;
      }
    }
  }

  function updateContentOverrides(user, content, template) {
    const { profile_uid, track_id, content_overrides = {} } = user;
    const { type, activity_id, course_id, event_id } = content;
    const body = { profile_uid, track_id, content_overrides };

    body.content_overrides = { ...body.content_overrides };

    if (type === 'activity') {
      body.content_overrides.activities = {
        ...body.content_overrides.activities,
        [activity_id]: template
      };
    }
    if (type === 'event') {
      body.content_overrides.events = {
        ...body.content_overrides.events,
        [course_id]: template
      };
    }
    if (type === 'externalEvent') {
      body.content_overrides.externalEvents = {
        ...body.content_overrides.externalEvents,
        [event_id]: template
      };
    }
    if (type === 'course') {
      body.content_overrides.courses = {
        ...body.content_overrides.courses,
        [course_id]: template
      };
    }
    ApiClass.learningsIdTypeTypeIdPatch({ id: $stateParams.track_id, type: 'assigned', type_id: profile_uid }, body, {
      queryParams: { manage: true }
    })
      .then(response => {
        updateContextOverrides(user, response.data.content_overrides);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  vm.toggleExempt = (user, content) => {
    const { type, activity_id, course_id } = content;

    let exempt;
    if (type === 'activity') {
      exempt = !get(user, `content_overrides.activities["${activity_id}"].exempt`, false);
    }
    if (type === 'event') {
      exempt = !get(user, `content_overrides.events["${course_id}"].exempt`, false);
    }
    if (type === 'course') {
      exempt = !get(user, `content_overrides.courses["${course_id}"].exempt`, false);
    }

    const exemptTemplate = {
      exempt,
      updated_at: new Date().toISOString()
    };

    updateContentOverrides(user, content, exemptTemplate);
  };

  vm.toggleCompleted = (user, content) => {
    const { type, activity_id, course_id, event_id } = content;

    let completed;
    if (type === 'activity') {
      completed = !get(user, `content_overrides.activities["${activity_id}"].completed`, false);
    }
    if (type === 'event') {
      completed = !get(user, `content_overrides.events["${course_id}"].completed`, false);
    }
    if (type === 'course') {
      completed = !get(user, `content_overrides.courses["${course_id}"].completed`, false);
    }
    if (type === 'externalEvent') {
      completed = !get(user, `content_overrides.externalEvents["${event_id}"].completed`, false);
    }

    const completedTemplate = {
      completed,
      updated_at: new Date().toISOString()
    };

    const validator = value => {
      if (value && !HelperClass.validateDate(value)) return 'Date is not valid';
      return;
    };

    if (completed) {
      return Swal.input('Completed Date', '(Optional)', 'MM/DD/YYYY', 'text', validator)
        .then(response => {
          const { value, dismiss } = response;
          if (dismiss) return;
          if (value) {
            completedTemplate.updated_at = HelperClass.cleanDate(value);
          }
          updateContentOverrides(user, content, completedTemplate);
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }

    updateContentOverrides(user, content, completedTemplate);
  };

  function activate() {
    $log.debug('Learning Track Course Status Controller Activated');

    if (!vm.profileuid) {
      vm.loaded = true;
      return;
    }

    ApiClass.learningsIdTypeTypeIdGet(
      { id: $stateParams.track_id, type: 'assigned', type_id: vm.profileuid },
      {},
      {
        queryParams: {
          manage: ResolveClass.isManageRoute(),
          joins: JSON.stringify({ content: true, assigned: true })
        }
      }
    ).then(({ data: { track } }) => {
      vm.user = track.progress;
      vm.loaded = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tables/trackCourseStatus/controller.js